import script from "./HTMazeGameSetting.vue?vue&type=script&setup=true&lang=js"
export * from "./HTMazeGameSetting.vue?vue&type=script&setup=true&lang=js"

import "./HTMazeGameSetting.vue?vue&type=style&index=0&id=0f21f220&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f21f220"]])

export default __exports__